import { Route } from '@angular/router';
import { AuthGuard } from '../../_guards/index';
import { DeveloperComponent } from './developer.component';

export const developerRoutes: Route[] = [
    { path: 'developer', component: DeveloperComponent }
];
